import * as React from 'react';
import Orders from './orders';


export const zeroPad = (num, places) => String(num).padStart(places, '0');




export const MyOrders = () => {


    return (
        <>
        <Orders theData={{ justPreStates: false , pageTitle : "فهرست سفارش های من" }} />
</>
    );
}
export default MyOrders;